// How to name a statement in the UI.
//
// Priority: the user's own nickname ("Sapphire (trip card)") beats the
// automatic label; the automatic label is "Bank ···last4" ("Chase ···1455") —
// the last-4 is what tells three same-bank cards apart (real bug: seven
// statements all labeled "elle's Chase"). Null when nothing identifying is
// stored (caller decides the fallback: filename, "No card holder set", etc.)
export function statementBaseLabel(stmt) {
  if (stmt.nickname) return stmt.nickname
  if (!stmt.bank_name && !stmt.card_last4) return null
  const bank = stmt.bank_name || 'Card'
  return stmt.card_last4 ? `${bank} ···${stmt.card_last4}` : bank
}
